define.alias("ember-power-select/components/power-select-multiple", "preview-grid/components/power-select-multiple");